'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    theme = Object.assign({}, baseTheme(theme), theme);

    // TODO refactor when aphrodite-jss keyframes bug will be fixed
    if (!Object.getPrototypeOf(this).__progressKeyframesSetted) {
        var doc = window.document,
            style = doc.createElement('style'),
            sheet = void 0;

        style.setAttribute('data-meta', 'p24c-progress-jss');

        doc.querySelector('head').insertBefore(style, doc.querySelector('head').firstChild);
        sheet = Array.prototype.find.call(doc.styleSheets, function (s) {
            return s.ownerNode === style;
        });

        Object.getPrototypeOf(this).__progressKeyframesSetted = true;
        try {
            sheet.insertRule('@keyframes component-progress-indeterminate { 0% { transform: translateX(-35%) scaleX(0); } 60% { transform: translateX(450%) scaleX(3); } 100% { transform: translateX(600%) scaleX(0); } }', sheet.cssRules && sheet.cssRules.length);
            sheet.insertRule('@-webkit-keyframes component-progress-indeterminate { 0% { transform: translateX(-35%) scaleX(0); } 60% { transform: translateX(450%) scaleX(3); } 100% { transform: translateX(600%) scaleX(0); } }', sheet.cssRules && sheet.cssRules.length);
            sheet.insertRule('@keyframes component-progress-indeterminate-short { 0% { transform: translateX(0%) scaleX(0.5); } 60% { transform: translateX(500%) scaleX(2.5); } 100% { transform: translateX(1000%) scaleX(1); } }', sheet.cssRules && sheet.cssRules.length);
            sheet.insertRule('@-webkit-keyframes component-progress-indeterminate-short { 0% { transform: translateX(0%) scaleX(0.5); } 60% { transform: translateX(500%) scaleX(2.5); } 100% { transform: translateX(1000%) scaleX(1); } }', sheet.cssRules && sheet.cssRules.length);
        } catch (e) {
            window.console && window.console.log(e);
        }
    }

    if (this.props.inline) {
        theme.display = 'inline-flex';
    }

    var position = {};

    if (this.props.global) {
        position = {
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 2
        };
    }

    var styleList = _aphroditeJss.StyleSheet.create({
        root: Object.assign({
            display: theme.display,
            width: theme.width,
            minWidth: theme.minWidth,
            alignItems: 'center',
            justifyContent: 'flex-start',
            flexDirection: 'column'
        }, position),
        label: {
            textAlign: 'center',
            padding: theme.gutter / 2 + 'px 0 ' + theme.gutter + 'px 0',
            color: theme.color,
            fontSize: theme.fontSize,
            lineHeight: theme.lineHeight
        },
        wrapper: {
            position: 'relative',
            height: '4px',
            display: 'block',
            width: '100%',
            backgroundColor: theme.progressBackground,
            borderRadius: '2px',
            overflow: 'hidden'
        },
        indeterminate: {
            background: theme.progressColor,

            '&:before': {
                content: '""',
                position: 'absolute',
                backgroundColor: 'inherit',
                top: 0,
                left: 0,
                bottom: 0,
                width: '20%',
                borderRadius: '2px',
                animation: 'component-progress-indeterminate 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) 0s infinite'
            },

            '&:after': {
                content: '""',
                position: 'absolute',
                backgroundColor: 'inherit',
                top: 0,
                left: 0,
                bottom: 0,
                width: '10%',
                borderRadius: '2px',
                transform: 'scaleX(0)',
                animation: 'component-progress-indeterminate-short 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.05s infinite'
            }
        }
    });

    return {
        root: (0, _aphroditeJss.css)(styleList.root),
        label: (0, _aphroditeJss.css)(styleList.label),
        wrapper: (0, _aphroditeJss.css)(styleList.wrapper),
        indeterminate: (0, _aphroditeJss.css)(styleList.indeterminate)
    };
};

var _aphroditeJss = require('aphrodite-jss');

var baseTheme = function baseTheme(theme) {
    return {
        display: 'flex',
        progressBackground: theme.elDivider,
        progressColor: theme.elAccent,

        color: theme.tInactive,
        fontSize: theme.tsNormal,
        lineHeight: 1.5,
        width: '100%',
        minWidth: 'auto'
    };
};